import { render, staticRenderFns } from "./EmployeeDetailsCard.vue?vue&type=template&id=be14a054&scoped=true"
import script from "./EmployeeDetailsCard.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetailsCard.vue?vue&type=style&index=0&id=be14a054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be14a054",
  null
  
)

export default component.exports